import React from "react";
import { tWithKeyAttr as t } from "../../../../i18nHelper";
import styles from "./TreatmentProgramBadge.module.css";

interface ITreatmentProgramBadgeProps {
  programName?: string;
  totalSessions?: number;
}

/**
 * Treatment Program Badge Component
 * Displays treatment program information
 */
const TreatmentProgramBadge: React.FC<ITreatmentProgramBadgeProps> = ({
  programName,
  totalSessions,
}) => {
  return (
    <div className={styles.treatmentProgramBadge}>
      <div className={styles.badgeHeader}>
        <span className={styles.badgeIcon}>📋</span>
        <div className={styles.badgeContent}>
          <div className={styles.badgeRow}>
            <span className={styles.badgeLabel}>
              {t("APPOINTMENTS_TREATMENT_PROGRAM")}:
            </span>
            <span className={styles.programName}>
              {programName || t("APPOINTMENTS_NO_NAME")}
            </span>
          </div>
          {totalSessions && (
            <div className={styles.badgeRow}>
              <span className={styles.badgeLabel}>
                {t("APPOINTMENTS_TOTAL_SESSIONS")}:
              </span>
              <span className={styles.programName}>{totalSessions}</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default TreatmentProgramBadge;
